import * as styles from "./ProductPanel.styles.ts";
import { DetailedProductView } from "src/admin/modules/b2b-gate-order/components/ExonnHub/components/DetailedProductView/DetailedProductView.tsx";
import { useExonnHubStore } from "src/admin/modules/b2b-gate-order/components/ExonnHub/useExonnHubStore.ts";
import { observer } from "mobx-react-lite";

export const ProductPanel = observer(() => {
  const store = useExonnHubStore();
  const openedProduct = store.openedProduct;
  const isFullscreen = store.isFullscreen;

  if (!openedProduct) {
    return null;
  }
  return (
    <div css={styles.root({ isFullscreen })}>
      <DetailedProductView
        key={
          // it is important to destroy components state when product changes
          openedProduct.id
        }
        data={openedProduct}
      />
    </div>
  );
});
